import type { FC, ReactNode } from 'react'

import { useRef } from 'react'
import { useScrollMotion } from '@/hooks/use-scroll-motion'

interface MotionRootProps {
    children: ReactNode
}

/**
 * Wrap every page's sections in this. Its effects run after all of its
 * children have mounted, so the page-wide scroll motion measures pins correctly.
 */
export const MotionRoot: FC<MotionRootProps> = ({ children }): ReactNode => {
    const rootRef = useRef<HTMLDivElement>(null)

    useScrollMotion(rootRef)

    return (
        <div ref={rootRef}>
            {children}
        </div>
    )
}
